import { render } from "./ZNWBdit.vue?vue&type=template&id=6576633c&scoped=true"
import script from "./ZNWBdit.vue?vue&type=script&lang=js"
export * from "./ZNWBdit.vue?vue&type=script&lang=js"

import "./ZNWBdit.vue?vue&type=style&index=0&id=6576633c&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6576633c"]])

export default __exports__